/* Ported from ac-cat-v2 assets/pdp-sustain.js. */
/* Atlas PDP sustainability band: mouse-follow spotlight (CSS variables --mx / --my). Glows and grain are CSS animations. */
(function () {
  function init(sec) {
    if (sec.__pdpSus) return;
    sec.__pdpSus = true;
    sec.addEventListener('mousemove', (e) => {
      const r = sec.getBoundingClientRect();
      sec.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      sec.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  }
  function boot() { document.querySelectorAll('[data-pdp-sus]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
